import { Injectable } from "@angular/core";
import { BehaviorSubject, firstValueFrom, Observable } from "rxjs";
import * as _ from 'lodash';
import { AuthService } from "../services/auth.service";
import { UtilsService } from "../services/utils.service";
import { HttpService } from "../../../http.service";
import { apiURL, EnvConfig } from "../../../env-config";
import { IFilter } from "../interfaces/filter.interface";

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    // private _TaskRequestsService: TaskRequestsService,
    private _AuthService: AuthService
  ) { }

  getNotifications(): Observable<any> {
    const user = this._AuthService.profile();
    let queryParams: string = '?' + this._utilsService.toQueryString({ user: user.id, company: user.company[0]?._id });
    return this._http.get(`${apiURL(EnvConfig.API_NOTIFICATIONS)}/user${queryParams}`);
  }

  markAsRead(notification: any): Observable<any> {
    let id = (typeof notification == 'string') ? notification : notification._id;
    return this._http.patch(`${apiURL(EnvConfig.API_NOTIFICATIONS)}/read/${id}`, {});
  }

  markAsUnRead(notification: any): Observable<any> {
    let id = (typeof notification == 'string') ? notification : notification._id;
    return this._http.patch(`${apiURL(EnvConfig.API_PRODUCTS)}/unread/${id}`, {});
  }

  /* ---------------------------------------------------- */
  private unreadTaskRequestCountSource = new BehaviorSubject<number>(0);
  unreadTaskRequestCount$ = this.unreadTaskRequestCountSource.asObservable();

  updateUnreadTaskRequestCount(count: number) {
    this.unreadTaskRequestCountSource.next(count);
  }

  /* ---------------------------------------------------- */
  private pendingTaskRequestCountSource = new BehaviorSubject<number>(0);
  pendingTaskRequestCount$ = this.pendingTaskRequestCountSource.asObservable();

  updatePendingTaskRequestCountSource(count: number) {
    this.pendingTaskRequestCountSource.next(count);
  }

  async countPendingTaskRequests() {
    const count = await this.getTaskRequestsCount();
    this.updatePendingTaskRequestCountSource(count);
    return count;
  }

  async getTaskRequestsCount() {
    const filter: IFilter = {
      company: this._AuthService.companyId(),
      limit: 10000,
      filters: {
        status: 'PENDING'
      }
    }
    return (await firstValueFrom(this.getTaskRequests(filter))).length;
  }

  getTaskRequests(filter?: IFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_TASK_REQUESTS)}${queryParams}`);
  }
}